/* ============================================================
   cart-drawer.js — La Boussole
   - Intercepte les soumissions de formulaires add-to-cart
   - Met à jour le compteur du header
   - Ouvre le drawer + peuple son contenu en live via /cart.js
   ============================================================ */
(function () {
  'use strict';

  // ----- Utilitaires -----
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn) { el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin'
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function changeLine(opts) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(opts),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // ----- Compteur header -----
  function updateHeaderCount(itemCount) {
    var el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = itemCount;
    if (itemCount > 0) el.classList.remove('is-hidden'); else el.classList.add('is-hidden');
  }

  // ----- Drawer DOM -----
  var drawer = $('[data-cart-drawer]');
  if (!drawer) return;

  var emptyEl = $('[data-cart-drawer-empty]', drawer);
  var listEl = $('[data-cart-drawer-list]', drawer);
  var footEl = $('[data-cart-drawer-foot]', drawer);
  var subtotalEl = $('[data-cart-drawer-subtotal]', drawer);

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    updateHeaderCount(cart.item_count);

    if (cart.item_count === 0) {
      emptyEl.removeAttribute('hidden');
      listEl.setAttribute('hidden', '');
      footEl.setAttribute('hidden', '');
      listEl.innerHTML = '';
      return;
    }

    emptyEl.setAttribute('hidden', '');
    listEl.removeAttribute('hidden');
    footEl.removeAttribute('hidden');

    var html = cart.items.map(function (item) {
      var image = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="' + escapeHtml(item.product_title) + '">'
        : '<div style="width:64px;height:64px;background:#222;border-radius:8px;"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</span>'
        : '';

      return ''
        + '<li class="cart-drawer__item" data-line-key="' + item.key + '">'
        +   image
        +   '<div>'
        +     '<div class="cart-drawer__item-title"><a href="' + item.url + '" style="color:inherit;text-decoration:none;">' + escapeHtml(item.product_title) + '</a></div>'
        +     variant
        +     '<div class="cart-drawer__item-qty">'
        +       '<button type="button" data-drawer-qty-minus="' + item.key + '" aria-label="Diminuer">−</button>'
        +       '<span>' + item.quantity + '</span>'
        +       '<button type="button" data-drawer-qty-plus="' + item.key + '" aria-label="Augmenter">+</button>'
        +     '</div>'
        +     '<button type="button" class="cart-drawer__item-remove" data-drawer-remove="' + item.key + '">Retirer</button>'
        +   '</div>'
        +   '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>'
        + '</li>';
    }).join('');

    listEl.innerHTML = html;
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function refresh() { return fetchCart().then(renderDrawer); }

  // ----- Event delegation -----
  on(document, 'click', function (e) {
    // Ouverture via icône panier du header
    var openBtn = e.target.closest('[data-cart-toggle]');
    if (openBtn) {
      e.preventDefault();
      refresh().then(openDrawer);
      return;
    }

    // Fermeture
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    // Vider
    if (e.target.closest('[data-cart-drawer-clear]')) {
      if (!confirm('Vider ton panier ?')) return;
      clearCart().then(refresh);
      return;
    }

    // Quantité +/-
    var plus = e.target.closest('[data-drawer-qty-plus]');
    var minus = e.target.closest('[data-drawer-qty-minus]');
    var removeBtn = e.target.closest('[data-drawer-remove]');

    if (plus || minus || removeBtn) {
      var key = (plus && plus.dataset.drawerQtyPlus) || (minus && minus.dataset.drawerQtyMinus) || (removeBtn && removeBtn.dataset.drawerRemove);
      var li = listEl.querySelector('[data-line-key="' + key + '"]');
      var current = li ? parseInt(li.querySelector('.cart-drawer__item-qty span').textContent, 10) : 0;
      var newQty = removeBtn ? 0 : (plus ? current + 1 : Math.max(0, current - 1));
      changeLine({ id: key, quantity: newQty }).then(refresh);
    }
  });

  // ----- Intercept add-to-cart forms -----
  on(document, 'submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }

    addToCart(fd).then(function (res) {
      if (!res.ok) {
        var msg = (res.data && res.data.description) || (res.data && res.data.message) || 'Impossible d\'ajouter au panier.';
        alert(msg);
        return;
      }
      return refresh().then(openDrawer);
    }).catch(function () {
      alert('Erreur réseau. Réessaie.');
    }).finally(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
    });
  });

  // ----- Fermer avec Escape -----
  on(document, 'keyup', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // ----- Init compteur depuis état réel au load -----
  fetchCart().then(function (cart) { updateHeaderCount(cart.item_count); });
})();
